import { render } from "./LessonPart.vue?vue&type=template&id=51343379&scoped=true"
import script from "./LessonPart.vue?vue&type=script&lang=js"
export * from "./LessonPart.vue?vue&type=script&lang=js"

import "./LessonPart.vue?vue&type=style&index=0&id=51343379&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aarhondakis\\Desktop\\lernapp_quellcode\\lernapp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51343379"]])

export default __exports__